module.exports = __webpack_public_path__ + "media/entities/5206-acba8bf7.png";